function clearAll() {
  this.setState({
    toastrList: [],
  });
}

function hideToastr(item) {
  const { toastrList } = this.state;

  if (toastrList.findIndex(i => i.id === item.id) !== -1) {
    toastrList.splice(
      toastrList.findIndex(i => i.id === item.id),
      1,
    );
  }

  this.setState({
    toastrList,
  });
}

function showToastr(item) {
  const itemClone = item;
  const timeout = item.timeout ? parseInt(item.timeout, 10) : 3000;
  const { toastrList } = this.state;

  itemClone.id = `${Math.round(Math.random() * 10 ** 10)}`;
  toastrList.push(itemClone);

  this.setState({
    toastrList,
  });

  if (!Number.isNaN(timeout)) {
    setTimeout(() => {
      hideToastr.bind(this)(itemClone);
    }, timeout);
  }
}

function createBaseContainer() {
  if (typeof window !== "undefined") {
    const toastrContainer = document.createElement("div");
    toastrContainer.className = "revv-toastr-holder";
    if (document.querySelectorAll("body")[0]) {
      document.querySelectorAll("body")[0].appendChild(toastrContainer);
    }
  }
}

export { clearAll, hideToastr, showToastr, createBaseContainer };
